module.exports = __webpack_public_path__ + "static/media/151.4b0ae463.wav";